import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import findResult from '@/utils/resultsHelper';
import { readStates, states } from '@/constants/lifecycle';
import NoRows from '@/components/table/NoRows';
import fetch, { fetchConfig } from '@/hooks/fetch';
import { datasetPermissions } from '../../sharing/constants';
import { fetchDatasetConditions, showAddDatasetCondition, showEditDatasetCondition } from '../actions';
import { datasetPerms } from '../../sharing/state/state';
import DatasetSettingsTable from '../../settings/components/DatasetSettingsTable';
import DatasetSettingsTableLoader from '../../settings/components/DatasetSettingsTableLoader';
import DatasetConditionRows from '../components/DatasetConditionRows';
import DatasetConditionsTableColumns, {
  useDatasetConditionsTableColumns,
} from '../components/DatasetConditionsTableColumns';

const DatasetConditionsTable = ({
  addDatasetCondition,
  canEdit,
  category,
  code,
  datasetConditions,
  fetchData,
  name,
  readStatus,
  showCondition,
}) => {
  fetch.useFetchByCode(fetchData, category, code, readStatus, fetchConfig([category, code, readStatus]));
  const columns = useDatasetConditionsTableColumns(datasetConditions);

  if (readStatus === states.PENDING) {
    return (
      <DatasetSettingsTableLoader />
    );
  }

  if (datasetConditions.length === 0) {
    return (
      <NoRows
        onClick={canEdit ? () => addDatasetCondition(category, code, name) : undefined}
        entity="dataset.condition"
        className="min-h-35"
      />
    );
  }

  return (
    <DatasetSettingsTable className="aridhia-dataset-conditions-table">
      <Table.Header fullWidth>
        <DatasetConditionsTableColumns
          addDatasetCondition={addDatasetCondition}
          canEdit={canEdit}
          category={category}
          code={code}
          columns={columns}
          name={name}
        />
      </Table.Header>
      <Table.Body>
        <DatasetConditionRows
          canEdit={canEdit}
          category={category}
          code={code}
          columns={columns}
          datasetConditions={datasetConditions}
          name={name}
          showCondition={showCondition}
        />
      </Table.Body>
    </DatasetSettingsTable>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { datasets: { update } } } },
  datasetConditions: { datasetConditions },
  datasetUsers: { permissions },
}, { category, code }) => {
  const item = findResult(datasetConditions, category, code) || { conditions: [], ...readStates };
  const permission = findResult(permissions, category, code) || datasetPerms();

  return {
    canEdit: update && permission[datasetPermissions.CONDITIONS],
    datasetConditions: item.conditions || [],
    readStatus: item.readStatus,
  };
};

const mapDispatchToProps = {
  fetchData: fetchDatasetConditions,
  addDatasetCondition: showAddDatasetCondition,
  showCondition: showEditDatasetCondition,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetConditionsTable);
